<template>
  <div class="figure__wrapper" :class="{'figure__wrapper-details': isDetails}">
      <svg :width="defaultSvgParams.width * figureSvgScale"
           :height="defaultSvgParams.height * figureSvgScale"
           :viewBox="`0 0 ${defaultSvgParams.width * figureSvgScale}
           ${defaultSvgParams.height * figureSvgScale}`"
           ref="figure"
           @mouseover="detectCursor()"
           @mouseout="unDetectCursor()"
           :style="{transform: `scale(${zoom})`}">
      <line
        x1="0"
        :y1="changeHeightUp"
        :x2="defaultSvgParams.width"
        :y2="changeHeightUp"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> //ruler horizontal top 2
      <line
        x1="0"
        :y1="changeHeightDown"
        :x2="defaultSvgParams.width"
        :y2="changeHeightDown"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler horizontal bottom 1
      <line
        :x1="changeWidthLeft"
        y1="0"
        :x2="changeWidthLeft"
        :y2="defaultSvgParams.height"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler vertical 1
      <line
        :x1="changeWidthRight"
        y1="0"
        :x2="changeWidthRight"
        :y2="defaultSvgParams.height"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler vertical 2
      <path :d="arrowWidth" fill="none" :stroke="isDetails ? arrowsColor : '#C6B4FB'"
        stroke-width="2" style="stroke-linecap: round;" v-if="!isNav"></path> // arrow width
      <!--<line
        :x1="(defaultSvgParams.width * figureSvgScale) / 2"
        :y1="changeHeightUp"
        :x2="(defaultSvgParams.width * figureSvgScale) / 2"
        :y2="changeHeightDown"
        stroke="red" stroke-width="4" style="stroke-linecap: round;" /> // center line
      <line
        :x1="changeWidthLeft"
        :y1="changeHeightDown"
        :x2="(defaultSvgParams.width * figureSvgScale) / 2"
        :y2="changeHeightUp"
        stroke="blue" stroke-width="4" style="stroke-linecap: round;" /> // top left side
      <line
        :x1="changeWidthLeft"
        :y1="changeHeightDown"
        :x2="changeWidthRight"
        :y2="changeHeightDown"
        stroke="brown" stroke-width="4" style="stroke-linecap: round;"/> // bottom side
      <line
        :x1="(defaultSvgParams.width * figureSvgScale) / 2"
        :y1="changeHeightUp"
        :x2="changeWidthRight"
        :y2="changeHeightDown"
        stroke="violet" stroke-width="4" style="stroke-linecap: round;"/> // top right side
      <line
        :x1="((this.defaultSvgParams.width * this.figureSvgScale) / 2)"
        :y1="changeHeightDown"
        :x2="arrowRightLength"
        :y2="changeHeightDown"
        stroke="lime" stroke-width="4"
        v-if="!isNav"/> // new arrow
      <line
        :x1="((this.defaultSvgParams.width * this.figureSvgScale) / 2)"
        :y1="changeHeightDown"
        :x2="arrowRightLength"
        :y2="changeHeightDown"
        :transform="`rotate(${90} ${arrowRightLength} ${changeHeightDown})`"
        stroke="lime" stroke-width="4"
        v-if="!isNav"/> // new arrow
      <line
        :x1="((this.defaultSvgParams.width * this.figureSvgScale) / 2)"
        :y1="changeHeightDown - (arrowRightLength -
        (((this.defaultSvgParams.width * this.figureSvgScale) / 2)))"
        :x2="arrowRightLength"
        :y2="changeHeightDown - (arrowRightLength -
        (((this.defaultSvgParams.width * this.figureSvgScale) / 2)))"
        stroke="lime" stroke-width="4"
        v-if="!isNav"/> // new arrow
      <line
        :x1="((this.defaultSvgParams.width * this.figureSvgScale) / 2)"
        :y1="changeHeightDown"
        :x2="arrowG"
        :y2="changeHeightDown"
        :transform="`rotate(${-45} ${((this.defaultSvgParams.width * this.figureSvgScale) / 2)}
        ${changeHeightDown})`"
        stroke="yellow" stroke-width="4"
        v-if="!isNav"/> // new arrow
      <line
        :x1="((this.defaultSvgParams.width * this.figureSvgScale) / 2)"
        :y1="changeHeightDown"
        :x2="arrowLeftLength"
        :y2="changeHeightDown"
        stroke="lime" stroke-width="4"
        v-if="!isNav"/> // new arrow
      <line
        :x1="((this.defaultSvgParams.width * this.figureSvgScale) / 2)"
        :y1="changeHeightDown"
        :x2="arrowLeftLength"
        :y2="changeHeightDown"
        :transform="`rotate(${-90} ${arrowLeftLength} ${changeHeightDown})`"
        stroke="lime" stroke-width="4"
        v-if="!isNav"/> // new arrow
      <line
        :x1="((this.defaultSvgParams.width * this.figureSvgScale) / 2)"
        :y1="changeHeightDown + (arrowLeftLength -
        (((this.defaultSvgParams.width * this.figureSvgScale) / 2)))"
        :x2="arrowLeftLength"
        :y2="changeHeightDown + (arrowLeftLength -
        (((this.defaultSvgParams.width * this.figureSvgScale) / 2)))"
        stroke="lime" stroke-width="4"
        v-if="!isNav"/> // new arrow
      <line
        :x1="((this.defaultSvgParams.width * this.figureSvgScale) / 2)"
        :y1="changeHeightDown"
        :x2="arrowG"
        :y2="changeHeightDown"
        :transform="`rotate(${-135} ${((this.defaultSvgParams.width * this.figureSvgScale) / 2)}
        ${changeHeightDown})`"
        stroke="yellow" stroke-width="4"
        v-if="!isNav"/> // new arrow-->
      <path :d="arrowDirectionRight" fill="none" :stroke="arrowStrokeColor"
            :stroke-width="strokeWidth" style="stroke-linecap: round;"
            :transform="`rotate(${arrowDirectionRightRotationDegree}
            ${arrowRightLength - arrowBias} ${arrowDirectionY})`"
            v-if="!isDetails"></path> // arrow Direction right
      <path :d="arrowDirectionLeft" fill="none" :stroke="arrowStrokeColor"
            :stroke-width="strokeWidth" style="stroke-linecap: round;"
            :transform="`rotate(${arrowDirectionLeftRotationDegree}
            ${arrowLeftLength + arrowBias} ${arrowDirectionY})`"
            v-if="!isDetails"></path> // arrow Direction right
      <defs v-if="isPlate">
        <clipPath id="figureLeftMask">
          <path :d="triangleLeftMask" fill="none" :stroke="figureStrokeColor"
           :stroke-width="strokeWidth"
            style="stroke-linecap: round;"></path> // triangle mask left
        </clipPath>
      </defs>
      <defs v-if="isPlate">
        <clipPath id="figureRightMask">
          <path :d="triangleRightMask" fill="none" :stroke="figureStrokeColor"
            :stroke-width="strokeWidth"
            style="stroke-linecap: round;"></path> // triangle mask right
        </clipPath>
      </defs>
      <text :x="`${(this.defaultSvgParams.width * this.figureSvgScale) / 2}`"
          :y="changeHeightDown + 20" fill="#333333"
          text-anchor="middle" v-if="isDetails">{{ slopeParams.width }} M</text>
      <g v-if="isDetails" clip-path="url(#figureRightMask)"><!--clip-path="url(#figureRightMask)"-->
        <g :transform="`rotate(-${platesRotationDegree}
              ${changeWidthRight} ${changeHeightDown})`">
          <g v-for="i in rowsCount" :key="i" class="row__overlay">
            <rect :x="changeWidthRight - (plateWidth * (i))"
                  :y="i % 2 === 0 ? (changeHeightDown - rowHeight)
                  - (plateHeight / 2)
                  : changeHeightDown - rowHeight"
                  :width="plateWidth - 1"
                  :height="i % 2 === 0 ? rowHeight + plateHeight : rowHeight"
                  fill="#F6F6F6" stroke="#999999"
                  stroke-width="1"
                  @mouseover="showRowInfo(i)"
                  @mouseout="hideRowInfo()"
                  ></rect>
            <line :x1="changeWidthRight - (plateWidth * (i))"
                  :y1="i % 2 === 0 ? (changeHeightDown - rowHeight)
                  + (plateHeight * n) - plateHeight / 2
                  : (changeHeightDown - rowHeight)
                  + (plateHeight * n)"
                  :x2="changeWidthRight - (plateWidth * (i)) + plateWidth - 1"
                  :y2="i % 2 === 0 ? (changeHeightDown - rowHeight)
                  + (plateHeight * n) - plateHeight / 2
                  : (changeHeightDown - rowHeight)
                  + (plateHeight * n)"
                  stroke="#999999"
                  stroke-width="1"
                  v-for="n in i % 2 === 0 ? (itemPerRow) : (itemPerRow - 1)" :key="n"></line>
                  <!--(plateHeight * n + (plateHeight / 2)) + shift-->
          </g>
        </g>
      </g>
      <g v-if="isDetails" clip-path="url(#figureLeftMask)"><!--clip-path="url(#figureLeftMask)"-->
        <g :transform="`rotate(${platesRotationDegree}
            ${changeWidthLeft} ${changeHeightDown})`">
          <g v-for="i in rowsCount" :key="i" class="row__overlay">
            <rect :x="changeWidthLeft + (plateWidth * (i - 1)) + 1"
                  :y="i % 2 === 0 ? (changeHeightDown - rowHeight)
                    - (plateHeight / 2)
                  : changeHeightDown - rowHeight"
                  :width="plateWidth - 1"
                  :height="i % 2 === 0 ? rowHeight + plateHeight : rowHeight"
                  fill="#F6F6F6" stroke="#999999"
                  stroke-width="1"
                  @mouseover="showRowInfo(i)"
                  @mouseout="hideRowInfo()"
                  ></rect>
            <line :x1="changeWidthLeft + (plateWidth * (i - 1)) + 1"
                  :y1="i % 2 === 0 ? (changeHeightDown - rowHeight)
                  + (plateHeight * n) - plateHeight / 2
                  : (changeHeightDown - rowHeight)
                  + (plateHeight * n)"
                  :x2="changeWidthLeft + (plateWidth * (i - 1)) + plateWidth"
                  :y2="i % 2 === 0 ? (changeHeightDown - rowHeight)
                  + (plateHeight * n) - plateHeight / 2
                  : (changeHeightDown - rowHeight)
                  + (plateHeight * n)"
                  stroke="#999999"
                  stroke-width="1"
                  v-for="n in i % 2 === 0 ? (itemPerRow) : (itemPerRow - 1)" :key="n"></line>
                  <!--(plateHeight * n + (plateHeight / 2)) + shift-->
            </g>
          </g>
        </g>
      <path :d="doubleSideTriangleVertical" fill="none" :stroke="figureStrokeColor"
            :stroke-width="strokeWidth"
            style="stroke-linecap: round;"></path> // double side triangle vertical
    </svg>
      <!--<div class="data" v-if="!isNav">
        <h1>coef: {{ scale }}</h1>
        <h1>scaleH: {{ scaleH }}</h1>
        <h1>scaleW: {{ scaleW }}</h1>
        <h1>arrowRightLength {{ arrowRightLength }}</h1>
        <h1>arrowLeftLength {{ arrowLeftLength }}</h1>
        <h1>{{ itemPerRow }}</h1>
        <h1>{{ rowsCount }}</h1>
      </div>-->
    <MyPopover
      :rowId = "rowId"
      :layersCount = "slopeFromState.slopeLayersCount"
      :plateHeight = "slopeFromState.materialSize.height"
      :plateWidth = "slopeFromState.materialSize.width"
      :windowWidth = "windowWidth"
      :materialAngle = "materialAngle"
      :fixtureCalculationThickness = "fixtureCalculationThickness"
      :masonryType="masonryType"
      :backEndRowsCount="backEndRowsCount"
      :hKr="hKr"
      :qKr="qKr"
      :y1="y1"
      :y2="y2"
      :mouseLeft = "mouseLeft"
      :mouseTop = "mouseTop"
    />
  </div>
</template>

<script>

import MyPopover from '../MyPopover.vue';

export default {
  props: {
    isNav: Boolean,
    defaultSvgParams: Object,
    isDetails: Boolean,
    isPlate: Boolean,
    navId: Number,
    zoom: Number,
    materialAngle: Number,
    fixtureCalculationThickness: Number,
    backEndRowsCount: Number,
    masonryType: String,
    hKr: Number,
    qKr: Number,
    y1: Number,
    y2: Number,
  },
  components: {
    MyPopover,
  },
  data() {
    return {
      rowId: 0,
      mouseTop: null,
      mouseLeft: null,
      windowWidth: null,
    };
  },
  watch: {
  },
  methods: {
    showRowInfo(i) {
      this.rowId = i;
    },
    hideRowInfo() {
      this.rowId = 0;
    },
    getCursorPosition(e) {
      this.mouseTop = e.clientY;
      this.mouseLeft = e.clientX;
    },
    detectCursor() {
      document.addEventListener('mousemove', this.getCursorPosition);
      this.windowWidth = window.innerWidth;
    },
    unDetectCursor() {
      document.removeEventListener('mousemove', this.getCursorPosition);
    },
  },
  computed: {
    slopeFromState() {
      return (!this.isNav && !this.isDetails) || (this.isDetails && this.isPlate)
        ? this.$store.getters.getSlope(this.slopeId)
        : this.$store.getters.getSlope(this.navId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    slopeParams() {
      return this.slopeFromState.slopeParams[0];
    },
    halfPlate() {
      return (this.columnsCount % 2 === 0)
        ? 0 : (((this.slopeFromState.materialSize.height / 1000) / 2) * this.scale);
    },
    rowsCount() {
      return Math.ceil((((this.slopeFromState.slopeParams[0].width
                         / this.slopeFromState.slopeParams[0].ratio) * 1000)
                       / this.slopeFromState.materialSize.width) / 2);
    },
    itemPerRow() {
      return Math.ceil((((Math.sqrt((this.slopeFromState.slopeParams[0].width ** 2)
                       + (((this.slopeFromState.slopeParams[0].width
                           / this.slopeFromState.slopeParams[0].ratio)) ** 2))) * this.scale)
                       / ((this.slopeFromState.materialSize.height / 1000) * this.scale)) / 2);
    },
    plateHeight() {
      return (this.slopeFromState.materialSize.height / 1000) * this.scale;
    },
    plateWidth() {
      return (this.slopeFromState.materialSize.width / 1000) * this.scale;
    },
    rowHeight() {
      return this.itemPerRow * this.plateHeight;
    },
    platesRotationDegree() { // высчитываем угол поворота
      return 90 - ((Math.atan(1 / this.slopeParams.ratio)) * 180 / Math.PI);
    },
    arrowStrokeColor() {
      return this.isNav ? '#C8C8C8' : '#999999';
    },
    figureStrokeColor() {
      return this.isNav || this.isDetails ? '#959595' : '#333333';
    },
    strokeWidth() {
      return this.isNav || this.isDetails ? 2 : 4;
    },
    arrowsColor() {
      return '#999999';
    },
    figureSvgScale() {
      return this.isNav ? this.defaultSvgParams.navScale : 1;
    },
    arrowDirectionSize() {
      return this.isNav ? 2.5 : 10;
    },
    arrowWidth() {
      return `M${this.changeWidthLeft},${this.changeHeightDown + 30}
      L${this.changeWidthRight},${this.changeHeightDown + 30}
      M${this.changeWidthLeft + 6},${this.changeHeightDown + 25}
      L${this.changeWidthLeft},${this.changeHeightDown + 30}
      M${this.changeWidthLeft + 6},${this.changeHeightDown + 35}
      L${this.changeWidthLeft},${this.changeHeightDown + 30}
      M${this.changeWidthRight - 6},${this.changeHeightDown + 25}
      L${this.changeWidthRight},${this.changeHeightDown + 30}
      M${this.changeWidthRight - 6},${this.changeHeightDown + 35}
      L${this.changeWidthRight},${this.changeHeightDown + 30}`;
    },
    arrowDirectionRight() {
      return `M${this.arrowDirectionRightStartX},${this.arrowDirectionY}
      L${this.arrowDirectionRightEndX},${this.arrowDirectionY}
      M${this.arrowDirectionRightEndX - this.arrowDirectionSize},${this.arrowDirectionY - this.arrowDirectionSize}
      L${this.arrowDirectionRightEndX},${this.arrowDirectionY}
      M${this.arrowDirectionRightEndX - this.arrowDirectionSize},${this.arrowDirectionY + this.arrowDirectionSize}
      L${this.arrowDirectionRightEndX},${this.arrowDirectionY}`;
    },
    arrowDirectionLeft() {
      return `M${this.arrowDirectionLeftStartX},${this.arrowDirectionY}
      L${this.arrowDirectionLeftEndX},${this.arrowDirectionY}
      M${this.arrowDirectionLeftEndX + this.arrowDirectionSize},${this.arrowDirectionY - this.arrowDirectionSize}
      L${this.arrowDirectionLeftEndX},${this.arrowDirectionY}
      M${this.arrowDirectionLeftEndX + this.arrowDirectionSize},${this.arrowDirectionY + this.arrowDirectionSize}
      L${this.arrowDirectionLeftEndX},${this.arrowDirectionY}`;
    },
    doubleSideTriangleVertical() {
      return `M${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightUp}
      L${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightDown}
      M${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightDown}
      L${this.changeWidthLeft},${this.changeHeightDown}
      M${this.changeWidthLeft},${this.changeHeightDown}
      L${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightUp}
      M${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightUp}
      L${this.changeWidthRight},${this.changeHeightDown}
      M${this.changeWidthRight},${this.changeHeightDown}
      L${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightDown}
      M${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightDown}`;
    },
    triangleLeftMask() {
      return `M${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightUp}
      L${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightDown}
      L${this.changeWidthLeft},${this.changeHeightDown} Z`;
    },
    triangleRightMask() {
      return `M${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightUp}
      L${(this.defaultSvgParams.width * this.figureSvgScale) / 2},${this.changeHeightDown}
      L${this.changeWidthRight},${this.changeHeightDown} Z`;
    },
    scaleH() { // коэффициент высоты
      return ((this.defaultSvgParams.baseHeight * this.figureSvgScale) * 100)
      / (this.slopeParams.width / (this.slopeParams.ratio));
    },
    scaleW() { // коэффициент ширины
      return ((this.defaultSvgParams.baseWidth * this.figureSvgScale) * 100)
      / this.slopeParams.width;
    },
    scale() { // применяемый коэффициент в зависимости от того какой из коэффициентов больше
      return (this.scaleW > this.scaleH) ? this.scaleH : this.scaleW;
    },
    changeWidthLeft() { // изменяем ширину влево
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              - ((this.slopeParams.width * this.scale) / 2));
    },
    changeWidthRight() { // изменяем ширину вправо
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              + ((this.slopeParams.width * this.scale) / 2));
    },
    changeHeightUp() { // изменяем высоту вверх
      return (((this.defaultSvgParams.height * this.figureSvgScale) / 2)
              - (((this.slopeParams.width / this.slopeParams.ratio / 4) * this.scale)));
    },
    changeHeightDown() { // изменяем высоту вниз
      return (((this.defaultSvgParams.height * this.figureSvgScale) / 2)
              + (((this.slopeParams.width / this.slopeParams.ratio / 4) * this.scale)));
    },
    arrowDirectionRightStartX() { // изменяем ширину направляющей стрелки влево
      return this.arrowRightLength - this.arrowBias + (this.arrowRightNewLength * 0.2);
    },
    arrowDirectionRightEndX() { // изменяем ширину напрвляющей стрелки вправо
      return (this.arrowRightLength - this.arrowBias)
        + this.arrowRightNewLength - (this.arrowRightNewLength * 0.2);
    },
    arrowDirectionLeftStartX() { // изменяем ширину направляющей стрелки влево
      return (this.arrowLeftLength + this.arrowBias) - (this.arrowRightNewLength * 0.2);
    },
    arrowDirectionLeftEndX() { // изменяем ширину напрвляющей стрелки вправо
      return (this.arrowLeftLength + this.arrowBias)
        - this.arrowRightNewLength + (this.arrowRightNewLength * 0.2);
    },
    arrowDirectionY() { // изменяем положение напрвляющей стрелки по высоте
      return this.changeHeightDown;
    },
    arrowRightLength() {
      return ((this.defaultSvgParams.width * this.figureSvgScale) / 2)
        + (((this.slopeParams.width * this.scale) / (this.slopeParams.ratio + 1)) / 2);
    },
    arrowLeftLength() {
      return ((this.defaultSvgParams.width * this.figureSvgScale) / 2)
        - (((this.slopeParams.width * this.scale) / (this.slopeParams.ratio + 1)) / 2);
    },
    arrowG() {
      return (this.arrowRightLength * Math.sqrt(2)) - 20;
    },
    arrowRightNewLength() {
      return (Math.sqrt((this.arrowRightLength ** 2) + ((this.arrowBias) ** 2)))
        - ((this.defaultSvgParams.width * this.figureSvgScale) / 2);
    },
    arrowBias() {
      return (((this.slopeParams.width * this.scale) / (this.slopeParams.ratio + 1))
              / this.slopeParams.ratio) / 2;
    },
    arrowDirectionRightRotationDegree() { // высчитываем угол поворота направляющей
      // стрелки что бы она была перпендикулярна гипотенузе
      return (((Math.atan(1 / this.slopeParams.ratio)) * 180 / Math.PI) - 90);
    },
    arrowDirectionLeftRotationDegree() { // высчитываем угол поворота направляющей
      // стрелки что бы она была перпендикулярна гипотенузе
      return (90 - ((Math.atan(1 / this.slopeParams.ratio)) * 180 / Math.PI));
      // return (((Math.atan(1 / this.slopeParams.ratio)) * 180 / Math.PI) - 135);
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
</style>
